import React from 'react'
import Sidebar from "../Common/Sidebar";
import Header from "../Common/Header";
import Setting from './Setting'



export default function index() {
    return (
        <div>
            <div className=" hidden xl:block" >
                <Sidebar />
            </div>

            <div className=" xl:ml-[270px]   ">
                <Header />
                <Setting />
            </div>

        </div>
    )
}
